import React from 'react';
import { Card, CardContent } from './ui/card';

export const StatsCard = ({ icon, title, value, subtitle, color = 'primary' }) => {
  const colorClasses = {
    primary: 'from-primary/10 to-primary/5 border-primary/20 text-primary',
    secondary: 'from-secondary/10 to-secondary/5 border-secondary/20 text-secondary',
    accent: 'from-accent/10 to-accent/5 border-accent/20 text-accent'
  };

  return (
    <Card className={`bg-gradient-to-br ${colorClasses[color]} border transition-all duration-300 hover:shadow-lg hover:scale-105`}>
      <CardContent className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className={`w-12 h-12 rounded-xl ${colorClasses[color].split(' ')[0]} ${colorClasses[color].split(' ')[1]} flex items-center justify-center ${colorClasses[color].split(' ')[3]}`}>
            {icon}
          </div>
        </div>
        
        <div>
          <p className="text-sm font-medium text-muted-foreground mb-2">{title}</p>
          <div className="text-3xl md:text-4xl font-bold text-foreground mb-1" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            {value}
          </div>
          <p className="text-xs text-muted-foreground">{subtitle}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default StatsCard;
